// extracted by mini-css-extract-plugin
export default {"container":"document-title_container__3mQ2b"};